import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { ToastService } from '../services/toast.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private toastService: ToastService
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    request = request.clone({ withCredentials: true });

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        const isAuthRoute = request.url.includes('/auth/basic') || request.url.includes('/auth/logout');
        if (error.status === 401 && !isAuthRoute && !this.authenticationService.isInitializing) {
          this.authenticationService.logout();
          this.router.navigate(['/signin']);
        } else if (error.status === 403) {
          this.toastService.show("You don't have permission to do that.", {
            classname: 'bg-danger text-white'
          });
        } else if (error.status === 0 || (error.status >= 500 && error.status < 600)) {
          this.toastService.show('Something went wrong. Please try again.', {
            classname: 'bg-danger text-white'
          });
        }
        return throwError(() => error);
      })
    );
  }
}
